import React, { useEffect, useState } from 'react';
import axios from '../api/axiosInstance';
import { Link } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';

const TrendingProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .post('/products/search-general/', {
        keyWord: 'electronics',
        pageIndex: '1',
      })
      .then((res) => {
        const productList =
          res.data?.aliexpress_ds_text_search_response?.data?.products?.selection_search_product?.slice(0, 8) || [];
        setProducts(productList);
      })
      .catch((err) => {
        console.error('Failed to fetch trending products:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="products" className="py-16 bg-gray-50 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          {/* <p className="text-sm font-semibold uppercase tracking-[0.18em] text-green-700 mb-2">
            Discover Global Products
          </p> */}
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
            Trending Products
          </h2>
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center min-h-[200px]">
            <FaSpinner className="text-green-600 text-4xl animate-spin mb-3" />
            <p className="text-lg text-green-700 font-medium animate-pulse">
              Loading trending products...
            </p>
          </div>
        ) : products.length === 0 ? (
          <p className="text-center text-gray-500">No products found.</p>
        ) : (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
              {products.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg shadow-sm hover:shadow-lg hover:scale-[1.02] transition-all duration-300 p-4 flex flex-col"
                >
                  <img
                    src={item.itemMainPic || 'https://placehold.co/300x300'}
                    alt={item.title || 'KambiHome Product'}
                    className="w-full h-48 object-cover rounded-md mb-4"
                  />
                  <h4 className="text-sm font-medium text-gray-800 line-clamp-2">
                    {item.title || 'Unnamed Product'}
                  </h4>
                  <p className="text-green-600 mt-2 font-semibold text-sm">
                    {item.salePriceFormat ||
                      `₦${parseInt(item.targetSalePrice || 0).toLocaleString()}`}
                  </p>

                  <Link
                    to={`/aliproduct/${item.itemId}`}
                    className="cursor-pointer mt-3 inline-block text-center text-sm font-semibold text-white bg-green-600 hover:bg-green-700 hover:scale-105 transition-all duration-300 rounded-md py-2"
                  >
                    View Details
                  </Link>
                </div>
              ))}
            </div>

            <div className="mt-10 text-center">
              <Link
                to="/products"
                className="cursor-pointer inline-block px-6 py-3 text-sm font-semibold text-white bg-green-600 hover:bg-green-700 hover:scale-105 transition-all duration-300 rounded-md"
              >
                View More Products
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default TrendingProducts;
